<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense color="#96298A" dark>
              <v-toolbar-title>Reporte General Pickups</v-toolbar-title>
              <v-divider class="mx-4" vertical></v-divider>
              <v-btn color="#FC8333" text outlined @click="showParams = !showParams">
                  <div v-if="!showParams">Ver Parametros <v-icon>mdi-arrow-right</v-icon></div>
                  <div v-else>Ocultar Parametros <v-icon>mdi-arrow-left</v-icon></div>
               </v-btn>
               <v-divider class="mx-4" vertical></v-divider>
               <v-spacer></v-spacer>
               <v-toolbar-items>
                   <v-divider class="mx-4" vertical></v-divider>
                  <v-text-field
                    v-model="searcher"
                    append-icon="mdi-file-search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    max-width="200px"
                    ></v-text-field>
                  <v-divider vertical class="mx-4"></v-divider>
                   <v-select
                        v-model="selectedHeaders"
                        label="Campos del Reporte"
                        :items="headers"
                        append-icon="mdi-format-columns"
                        return-object
                        clearable
                        filled
                        multiple
                    >
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 2" x-small color="#FC8333" text-color="black">
                                <span>{{ item.text }}</span>
                            </v-chip>
                            <span v-if="index === 2" class="grey--text caption">(+{{ selectedHeaders.length - 2 }} otros)</span>
                        </template>
                    </v-select>
                    <v-divider class="mx-4" vertical></v-divider>
                    <v-btn icon x-large @click="exportToExcel()"><v-icon>mdi-microsoft-excel</v-icon></v-btn>
                    <v-divider class="mx-4" vertical></v-divider>
               </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row dense>
                <v-col cols="12" sm="12" md="3" v-if="showParams">
                    <v-card>
                        <v-card-subtitle>Parametros</v-card-subtitle>
                        <v-card-text>
                          <v-row dense>
                              <v-radio-group row label="Fecha de Reporte:" v-model="fechaRep">
                                <v-radio :value="0" label="Creación"></v-radio>
                                <v-radio :value="1" label="Recolecta"></v-radio>
                              </v-radio-group>
                          </v-row>
                            <v-row dense>
                                <v-col>
                                    <v-text-field v-model="desde" type="date" clearable label="Desde"></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="hasta" type="date" clearable label="Hasta"></v-text-field>
                                </v-col>
                            </v-row>
                        <v-row dense>
                            <v-col>
                                <v-combobox
                                    v-model="courier"
                                    label="Courier"
                                    :items="couriers"
                                    append-icon="filter"
                                    item-value="id"
                                    item-text="nombre"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-combobox
                                    v-model="estatus"
                                    label="Estatus"
                                    :items="estatuses"
                                    append-icon="mdi-sticker-check"
                                    item-value="id"
                                    item-text="descripcion"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-combobox
                                    v-model="pendfin"
                                    label="Pendientes / Finalizados"
                                    :items="pendfines"
                                    append-icon="mdi-playlist-check"
                                    item-value="cod"
                                    item-text="descripcion"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        </v-card-text>
                        <v-card-actions dense>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" dark outlined @click="getData()">Generar <v-icon>mdi-file</v-icon></v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" :md="showParams ? '9' : '12'">
                    <v-card>
                        <v-card-subtitle>Reporte</v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-data-table :headers="showHeaders" :items="guias" :search="searcher">
                                        <template v-slot:item.created_at="{ item }">
                                            {{formatDate(item.created_at)}}
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import utils from '../utils/utils'
const XLSX = require('xlsx')
export default {
created: function(){},
data() {
    return{
        showParams: true,
        desde: null,
        hasta: null,
        searcher: null,
        fechaRep: 0,
        couriers: [],
        courier: null,
        estatuses: [],
        estatus: null,
        pendfines: [
            {descripcion: 'Pendientes', cod: 'P'},
            {descripcion: 'Finalizadas', cod: 'F'},
        ],
        pendfin: null,
        guias: [],
        headers: [
            { text: "Fecha Creacion", value: "created_at", sortable: false },
            { text: "Fecha Recolecta", value: "fecha_recolecta", sortable: false },
            { text: "Hora Recolecta", value: "hora_recolecta", sortable: false },
            { text: "Hora Cierre", value: "cerrado_a", sortable: false },
            { text: "Indicaciones", value: "indicaciones", sortable: false },
            { text: "Cliente", value: "cliente", sortable: false },
            { text: "Contacto", value: "contacto", sortable: false },
            { text: "Clase", value: "clase", sortable: false },
            { text: "Tipo", value: "tipo", sortable: false },
            { text: "Observaciones Recep", value: "observacionesrecep", sortable: false },
            { text: "Estatus", value: "estatus.descripcion", sortable: false },
            { text: "Hora Retiro", value: "horaretiro", sortable: false },
            { text: "Observaciones Disp", value: "observacionesdisp", sortable: false },
            { text: "Origen", value: "origen", sortable: false },
            { text: "Destino", value: "destino", sortable: false },
            { text: "Direccion", value: "direccion", sortable: false },
            { text: "Peso", value: "peso", sortable: false },
            { text: "Dimensiones", value: "dimensiones", sortable: false },
            { text: "Courier", value: "courier.nombre", sortable: false },
            { text: "Finalizado", value: "finalizado", sortable: false },
            { text: "Creado Por", value: "usuario.nombre", sortable: false },
        ],
        selectedHeaders: [],
        isCliente: false,
    }
},
methods:{
    getEstatuses: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'estatusp').then((result) => {
            this.estatuses = result
        }).catch((err) => {
            console.log(err);
        })
    },
    getCouriers: function(){
      apicon.getDataApi(apicon.getApiBaseUrl() + 'courier').then((result) => {
        this.couriers = result;
      }).catch((err) => {
        console.log(err)
      })
    },
    getData: function(){
        apicon.saveDataApi(apicon.getApiBaseUrl() + 'reportepickups',{
            fechaRep: this.fechaRep,
            desde: this.desde,
            hasta : this.hasta,
            courier: this.courier != null ? this.courier.id : null,
            estatus: this.estatus != null ? this.estatus.id : null,
            pendifn: this.pendfin != null ? this.pendfin.cod : null,
            }).then((result) => {
            this.guias = result;
            this.showParams = false;
        }).catch((err) => {
            console.log(err);
        });
    },
    formatDate: function(date){
        return utils.formatDate(date)
    },
    exportToExcel: function(){
        //Map Data to new Json
        let newJson = this.guias.map(rec => {
            let obj = {
              "Fecha Creacion" :  new Date (new Date(rec.created_at).toISOString().substring(0,10) + 'T00:00:00'),
              "Fecha Recolecta" : rec.fecha_recolecta != null ? new Date(rec.fecha_recolecta + 'T00:00:00') : '',
              "Hora Recolecta" : rec.hora_recolecta,
              "Hora Cierre" : rec.cerrado_a,
              "Indicaciones": rec.indicaciones,
              "Cliente" : rec.cliente,
              "Contacto" : rec.contacto,
              "Clase" : rec.clase,
              "Tipo" : rec.tipo,
              "Observaciones Recep" : rec.observacionesrecep,
              "Estatus" : rec.estatus != null ? rec.estatus.descripcion : null,
              "Hora Retiro" : rec.horaretiro,
              "Observaciones Disp" : rec.observacionesdisp,
              "Origen" : rec.origen,
              "Destino" : rec.destino,
              "Direccion" : rec.direccion,
              "Peso" : rec.peso,
              "Dimensiones" : rec.dimensiones,
              "Courier" : rec.courier != null ? rec.courier.nombre : null,
              "Finalizado" : rec.finalizado,
              "Creado Por" : rec.usuario != null ? rec.usuario.nombre : null,
            }
            //Eliminar las columnas no seleccionadas
            Object.keys(obj).forEach((key) => {
                const found = this.selectedHeaders.some(el => el.text === key);
                if(!found){
                    delete obj[key]
                }
            })
            return obj;
        });
        let data = XLSX.utils.json_to_sheet(newJson);
        const workbook = XLSX.utils.book_new();
        const filename = 'Reporte Pickups';
        //Fit columns
        const wscols = utils.getAutoFitColumns(newJson);
        data["!cols"] = wscols;

        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
},
computed:{
    showHeaders () {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
},
mounted: function(){
    apicon.setAuthHeaders();
    this.getEstatuses();
    this.getCouriers();
    this.selectedHeaders = this.headers;
    this.isCliente = localStorage.getItem("cliente");
}
}
</script>
